export const ROUTES_LIST = {
  paymentSuccess: "/payment-successful",
  paymentFailure: "/payment-failure",
  forbidden403: "/403",
  // temporary
  rootPath: "/",
  antd: "/antd",
  referralPath: "/referral",
  salesPath: "/sales",
  splashScreen: "/splash",
  emailConfirmationPath: "/email-confirmation/:id",
  signInV2: "/auth/sign-in",
  signUpV2: "/auth/sign-up",
  newPassword: "/auth/new-password",
  signUpOptions: "/auth/sign-up/options",
  confirmEmail: "/auth/sign-up/confirm-email",
  confirmPhone: "/auth/sign-up/confirm-phone",
  confirmInfo: "/auth/sign-up/confirm-info",
  passwordRecovery: "/auth/password-recovery",
  passwordRecoveryEnterCode: "/auth/password-recovery/enter-code",
  passwordRecoveryCreatePassword: "/auth/password-recovery/create-password",
  passwordRecoverySuccess: "/auth/password-recovery/success",
  homePath: "/home",
  cancellationpolicy: "/cancellation-policy",
  partner: "/partner/:partnerSlug",
  proPersonalInfoRootPath: "/pro/personal-info",
  proPersonalInfoProfileInfo: "/pro/personal-info/profile-information",
  proPersonalInfoProfileImages: "/pro/personal-info/profile-images",
  proPersonalInfoAddressesPath: "/pro/personal-info/addresses",
  proPersonalInfAdventureMode: "/pro/personal-info/adventure-mode",
  proPersonalInfoLicenses: "/pro/personal-info/licenses-and-certifications",
  proPersonalInfoPayment: "/pro/personal-info/connect-payment-provider",
  proRootPath: "/pro",
  proHomeRootPath: "/pro/home",
  proSettingsRootPath: "/pro/home/settings",
  proSettingsStripeAccount: "/pro/home/settings/stripe-account",
  proSettingsPaymentProviders: "/pro/home/settings/payment-providers",
  proSettingsProfileInformation: "/pro/home/settings/profile-information",
  proSettingsAdventureMode: "/pro/home/settings/branding",
  proSettingsLicenses: "/pro/home/settings/licenses",
  proSettingsProfileImages: "/pro/home/settings/profile-images",
  proSettingsLoginAndSecurity: "/pro/home/settings/login-and-security",
  proSettingsGoogleCalendar: "/pro/home/settings/google-calendar",
  proMessagesRootPath: "/pro/home/messages",
  proSettingsWebsiteIntegration: "/pro/home/settings/website-integration",
  proSettingsAccountManagement: "/pro/home/settings/account-management",
  proSettingsCustomTemplate: "/pro/home/settings/custom-template",
  proSettingsTemplateDetails: "/pro/home/settings/template-details",
  proSettingsEditTemplateDetails: "/pro/home/settings/template-details/:id",
  proSettingsTaxesAndFees: "/pro/home/settings/taxes-and-fees",
  proSettingsCommunicationModule: "/pro/home/settings/communication-module",
  proSettingsCalendarExperienceColors: "/pro/home/settings/calendar-experience-colors",
  proSettingsPricingPromotions: "/pro/home/settings/pricing-promotions",
  confirmPassword: "/user/create-token/:token",
  setNewPasswordForGuest: "/user/guest/set-password/:token",

  proExperiencesPath: "/pro/home/experiences",
  proExperiencePath: "/pro/home/experiences/:id",
  proExperiencePathDraft: "/pro/home/experiences?route=draft",
  proExperiencePathPublishedPath: "/pro/home/experiences?route=published",
  proExperiencePathDeactivatedPath: "/pro/home/experiences?route=deactivated",

  proNewListingRootPath: "/pro/home/experiences/:id/wizard",
  proNewListingDetailsPath: "/pro/home/experiences/:id/wizard/details",
  proNewListingSchedulingPath: "/pro/home/experiences/:id/wizard/scheduling",
  proNewListingMediaPath: "/pro/home/experiences/:id/wizard/media",
  proNewListingResourcesPath: "/pro/home/experiences/:id/wizard/resources",
  proNewListingLocationPath: "/pro/home/experiences/:id/wizard/location",
  proNewListingPreviewPath: "/pro/home/experiences/:id/wizard/preview",
  proNewListingDigitalWaiverPath: "/pro/home/experiences/:id/wizard/digital_waiver",
  proNewListingTaxFeesPath: "/pro/home/experiences/:id/wizard/tax_fees",

  // New wizard (single-route, step via ?step= query param) — coexists with old wizard
  proNewExperienceV2Path: "/pro/home/experiences/:id/v2",
  proNewExperienceV2PreviewPath: "/pro/home/experiences/:id/v2?step=preview",
  proEditExperienceV2Path: "/pro/home/experiences/:id/v2/edit",
  proEditExperienceV2PreviewPath: "/pro/home/experiences/:id/v2/edit?step=preview",

  // reskin routes
  proCalendarPath: "/pro/home/calendar",
  guideRootPath: "/pro/home",
  guideDashboardPath: "/pro/home/calendar", // Default to calendar; AI Dashboard at /pro/home/dashboard when enabled
  guideAIDashboardPath: "/pro/home/dashboard",
  guideDashboardBookingNewPath: "/pro/home/dashboard/bookings/new",
  guideDashboardBookingEditPath: "/pro/home/dashboard/bookings/:id/edit",
  guideDashboardJournalNewPath: "/pro/home/dashboard/journal_notes/new",
  guideDashboardJournalEditPath: "/pro/home/dashboard/journal_notes/:id/edit",

  guideDashboardUnavailableDayManagePath: "/pro/home/dashboard/unavailable_days/manage",
  guideBookingsPath: "/pro/home/bookings",
  guideBookingDetailsPath: "/pro/home/bookings/:id",
  guideBookingNewPath: "/pro/home/bookings/new",
  guideBookingEditPath: "/pro/home/bookings/:id/edit",
  guideBookingBookAgainPath: "/pro/home/bookings/:id/book_again",
  guideClientsPath: "/pro/home/clients",
  guideClientNewPath: "/pro/home/clients/new",
  guideClientPath: "/pro/home/clients/:id",
  guideClientEditPath: "/pro/home/clients/:id/edit",
  guideImportClientsListPath: "/pro/home/clients/import_client_list",
  guideFailedClientsListPath: "/pro/home/clients/failed_client_list",
  guideImportClientHistory: "/pro/home/clients/import_client_history",
  guideImportClientDetail: "/pro/home/clients/import_client_history/:id",
  guideClientManageGroup: "/pro/home/clients/manage_group",
  guideClientEmailActionPath: "/pro/home/clients/email_action",
  guideClientTextActionPath: "/pro/home/clients/text_action",
  guideClientMessageActionPath: "/pro/home/clients/message_action",
  guideTripsPath: "/pro/home/trips",
  guideTripPath: "/pro/home/trips/:id",
  guideBoatsPath: "/pro/home/boats",
  guideResourcesPath: "/pro/home/resources",
  guideResourcesEquipmentPath: "/pro/home/resources/equipment",
  guideResourcesCrewPath: "/pro/home/resources/crew",
  guideCrewMemberEditFromListPath: "/pro/home/resources/crew/edit/:id",
  guideEquipmentDetailsPath: "/pro/home/resources/equipment/:id",
  guideEquipmentAddPath: "/pro/home/resources/equipment/add",
  guideEquipmentEditPath: "/pro/home/resources/equipment/:id/edit",
  guideEquipmentDuplicatePath: "/pro/home/resources/equipment/:id/duplicate",
  guideCrewMemberDetailsPath: "/pro/home/resources/crew/:id/details",
  guideCrewMemberCalendarPath: "/pro/home/resources/crew/:id/calendar",
  guideCrewMemberEditPath: "/pro/home/resources/crew/:id/edit",
  guideAddNewBoatPath: "/pro/home/boats/new",
  guideEditBoatPath: "/pro/home/boats/:id/edit",
  guideMessagesPath: "/pro/home/messages",
  guideAccountingPath: "/pro/home/accounting",
  guideAccountingAddExpancePath: "/pro/home/accounting/new",
  guideAccountingEditExpancePath: "/pro/home/accounting/:id/edit",
  guideMarketingPath: "/pro/home/marketing",
  guideMarketingPostNewPath: "/pro/home/marketing/new",
  guideMarketingPostEditPath: "/pro/home/marketing/:id/edit",
  guideMarketingTemplatesPath: "/pro/home/marketing/templates",
  guideMarketingTemplatesParentsPath: "/pro/home/marketing/templates/parents",
  guideMarketingTemplateNewPath: "/pro/home/marketing/templates/new",
  guideMarketingTemplateEditPath: "/pro/home/marketing/templates/:id/edit",
  guideFaqPath: "/pro/home/faqs",
  contactSupportPath: "/pro/home/contact-support",

  publicGuidePath: "/pro/home/preview/:slug",
  publicGuideTripsPath: "/pro/home/preview/:slug/trips",
  publicGuideLocationPath: "/pro/home/preview/:slug/location",
  publicGuideBoatsPath: "/pro/home/preview/:slug/boats",
  publicGuidePostsPath: "/pro/home/preview/:slug/posts",
  publicGuideReviewsPath: "/pro/home/preview/:slug/reviews",

  // Add these new routes for experience editing
  proEditExperiencePath: "/pro/home/experiences/:id/edit",
  proEditExperienceDetailsPath: "/pro/home/experiences/:id/edit/details",
  proEditExperienceSchedulingPath: "/pro/home/experiences/:id/edit/scheduling",
  proEditExperienceMediaPath: "/pro/home/experiences/:id/edit/media",
  proEditExperienceResourcesPath: "/pro/home/experiences/:id/edit/resources",
  proEditExperienceLocationPath: "/pro/home/experiences/:id/edit/location",
  proEditExperiencePreviewPath: "/pro/home/experiences/:id/edit/preview",
  proEditExperienceDigitalWaiverPath: "/pro/home/experiences/:id/edit/digital_waiver",
  proEditExperienceTaxFeesPath: "/pro/home/experiences/:id/edit/tax_fees",
  ProDigitalWaiverAndContracts: "/pro/home/documents-added",
  ProDigitalWaiverNew: "/pro/home/documents-added/new",
  ProDigitalWaiverEdit: "/pro/home/documents-added/:id/edit",
  ProDigitalWaiverView: "/pro/home/documents-added/:id/view",

  proEditExperienceDeactiveBackRoutePath: "/pro/home/experiences/:id/edit/preview?readOnlyPreview=true&route=deactivated",
  proEditExperiencePublishBackRoutePath: "/pro/home/experiences/:id/edit/preview?readOnlyPreview=true&route=published",
  proEditExperienceDraftBackRoutePath: "/pro/home/experiences/:id/edit/preview?readOnlyPreview=true&route=draft",

  proEditExperienceDeactivateBackRoutePathDetails: "/pro/home/experiences/:id/edit/details?route=deactivated",
  proEditExperiencePublishBackRoutePathDetails: "/pro/home/experiences/:id/edit/details?route=published",
  proEditExperienceDraftBackRoutePathDetails: "/pro/home/experiences/:id/edit/details?route=draft",

  proEditExperienceDeactivateBackRoutePathScheduling: "/pro/home/experiences/:id/edit/scheduling?route=deactivated",
  proEditExperiencePublishBackRoutePathScheduling: "/pro/home/experiences/:id/edit/scheduling?route=published",
  proEditExperienceDraftBackRoutePathScheduling: "/pro/home/experiences/:id/edit/scheduling?route=draft",

  proEditExperienceDeactivateBackRoutePathMedia: "/pro/home/experiences/:id/edit/media?route=deactivated",
  proEditExperiencePublishBackRoutePathMedia: "/pro/home/experiences/:id/edit/media?route=published",
  proEditExperienceDraftBackRoutePathMedia: "/pro/home/experiences/:id/edit/media?route=draft",

  proEditExperienceDeactivateBackRoutePathResources: "/pro/home/experiences/:id/edit/resources?route=deactivated",
  proEditExperiencePublishBackRoutePathResources: "/pro/home/experiences/:id/edit/resources?route=published",
  proEditExperienceDraftBackRoutePathResources: "/pro/home/experiences/:id/edit/resources?route=draft",

  proEditExperienceDeactivateBackRoutePathLocation: "/pro/home/experiences/:id/edit/location?route=deactivated",
  proEditExperiencePublishBackRoutePathResLocation: "/pro/home/experiences/:id/edit/location?route=published",
  proEditExperienceDraftBackRoutePathLocation: "/pro/home/experiences/:id/edit/location?route=draft",

  proEditExperienceDeactivateBackRoutePathPreview: "/pro/home/experiences/:id/edit/preview?route=deactivated",
  proEditExperiencePublishBackRoutePathResPreview: "/pro/home/experiences/:id/edit/preview?route=published",
  proEditExperienceDraftBackRoutePathPreview: "/pro/home/experiences/:id/edit/preview?route=draft",

  proEditExperiencePublishBackRoutePathDigitalWaiver: "/pro/home/experiences/:id/edit/digital_waiver?route=published",
  proEditExperienceDraftBackRoutePathDigitalWaiver: "/pro/home/experiences/:id/edit/digital_waiver?route=draft",
  proEditExperienceDeactivateBackRoutePathDigitalWaiver: "/pro/home/experiences/:id/edit/digital_waiver?route=deactivated",

  proEditExperiencePublishBackRoutePathTaxFees: "/pro/home/experiences/:id/edit/tax_fees?route=published",
  proEditExperienceDraftBackRoutePathTaxFees: "/pro/home/experiences/:id/edit/tax_fees?route=draft",
  proEditExperienceDeactivateBackRoutePathTaxFees: "/pro/home/experiences/:id/edit/tax_fees?route=deactivated",

  proGuideProfilePath: "/guide-profile/:slug",
  guideProfileExperiencesBookingPath: "/guide-profile/experience_booking/:uuid/:id",

  embeddedExperienceListing: "/embedded/experience_listing/:uuid",
  embeddedExperienceDetail: "/embedded/experience_detail/:uuid/:id",
  embeddedExperienceBooking: "/embedded/experience_booking/:uuid/:id",
  embeddedExperienceBookingConfirmation: "/embedded/experience_booking_confirmation/:uuid/:id",

  ClientEmailActionPath: "/clients/email_action",
  ClientTextActionPath: "/clients/text_action",
  ClientMessageActionPath: "/clients/message_action",
  // Client routes
  faqPath: "/faq",
  termsAndConditionsPath: "/terms-and-conditions",
  privacyPolicyPath: "/privacy-policy",
  tripsPath: "/trips",
  tripPath: "/trips/:id",
  clientRootPath: "/client",
  clientFavoritesPath: "/client/favorites",
  clientMessagesPath: "/client/messages",
  clientProfileRootPath: "/client/profile/:id",
  clientSettingsRootPath: "/client/settings",
  clientSettingsPaymentPath: "/client/settings/payment",
  clientSettingsPasswordPath: "/client/settings/password",
  clientSettingsNotificationsPath: "/client/settings/notifications",
  bookingWizardPath: "/booking_trips/wizard/:id",
  clientBookingsPath: "/client/booking_trips",
  clientBookingsPastTripsPath: "/client/booking_trips/past",
  clientBookingPath: "/client/booking_trips/:uuid",
  clientBookingWizardRootPath: "/client/booking_trips/:id/wizard",
  clientBookingWizardStep1Path: "/client/booking_trips/:uuid/wizard/booking",
  clientBookingWizardStep2Path: "/client/booking_trips/:uuid/wizard/accessibility",
  clientBookingWizardStep3Path: "/client/booking_trips/:uuid/wizard/payment",
  clientBookingWizardStep4Path: "/client/booking_trips/:uuid/wizard/confirmation",
  clientBookingConfirmation: "/client/bookingConfirmation/:id",
  bookingConfirmation: "/guest/bookingConfirmation/:id",
  bookingConfirmationLegacy: "/guest/bookingConfirmationV1/:id",
  clientSharedWaivers: "/client/shared_waivers/:id",
  // clientSharedWaivers: "/client/shared_waivers",
  clientWaiverThankYou: "/client/waiver/thank-you",
  clientTripBookingWaiverPath: "/client/trip_booking/:uuid/waiver/:token",
  clientTripBookingSharedWaiverPath: "/client/trip_booking/:uuid/shared_waiver/:id",
  clientBookingWaiverResumePath: "/client/booking_trips/:uuid/waiver_submissions/:token",
  publicBookingPath: "/public/booking/:uuid",

  shortLinkRedirect: "/s/:token",

  //staff routes
  proStaffPath: "staff",
  proStaffDetailPath: ":id",
  proStaffEditPath: "/pro/home/staff/:id/edit",
}

export const dynamicRoute = (path) => {
  const requiredParams = path.match(/:\w+/g) || []
  const route = (params = {}, search = {}) => {
    const searchString = new URLSearchParams(search).toString()
    if (!Object.keys(params).length) return searchString ? `${path}?${searchString}` : path
    const errors = []
    const dynamicPath = requiredParams.reduce((link, param) => {
      const receivedParam = params[param.replace(":", "")]
      if (receivedParam === undefined) {
        errors.push(`"${param}" param is required`)
        return link
      }
      return link.replace(param, receivedParam)
    }, path)

    if (errors.length) {
      console.error(`For path "${path}" ${errors.join(", ")}`)
    }

    return searchString ? `${dynamicPath}?${searchString}` : dynamicPath
  }
  return route
}

export const routes = Object.keys(ROUTES_LIST).reduce(
  (acc, routeAlias) => ({ ...acc, [routeAlias]: dynamicRoute(ROUTES_LIST[routeAlias]) }),
  {}
)
